import { z } from "zod";

export const documentSubmissionCheckSchema = z.object({
  documentsSubmittable: z.boolean().optional(),
});

export type DocumentSubmissionCheckValues = z.infer<typeof documentSubmissionCheckSchema>;
